var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-box"},[_c('v-row',{attrs:{"cols":"12"}},_vm._l((_vm.serviceList),function(service,idx){return _c('v-col',{key:idx,staticClass:"text-left service-col",attrs:{"cols":"6"}},[_c('img',{attrs:{"width":"8","height":"8","src":require("@/assets/images/dot.svg"),"alt":""}}),_c('p',[_vm._v(_vm._s(service))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }